import { createSlice, current } from '@reduxjs/toolkit';
import { getDataFinance } from '../dataFinance/thunk';

export const initialState = {
	itemDataFinanceDetail12Months: null,
	itemDataFinanceDetail3Years: null,

	isSuccess: false,
	isLoading: false,
	requireCloseModal: false,
};

const DataFinanceSlice = createSlice({
	name: 'DataFinance',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getDataFinance.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;

			if (action.payload.dataType === '12Months') {
				state.itemDataFinanceDetail12Months = action.payload.data;
			} else if (action.payload.dataType === '3Years') {
				state.itemDataFinanceDetail3Years = action.payload.data;
			}
		});
		builder.addCase(getDataFinance.pending, state => {
			state.isLoading = true;
			state.isSuccess = null;
			state.error = null;
		});
		builder.addCase(getDataFinance.rejected, (state, action) => {
			state.isLoading = false;
			state.isSuccess = false;
			state.error = action.error.message;
		});
	},
});

export const { setRequireCloseModal } = DataFinanceSlice.actions;

export default DataFinanceSlice.reducer;
